import BuildingSidebar from 'components/buildingsidebar/building-sidebar';
import MaterialsSidebar from 'components/materialssidebar/materials-sidebar';
import Notification from 'components/notification/notification';
import OptionParametersSidebar from 'components/option-parameters-sidebar/option-parameters-sidebar';
import OptionsSidebar from 'components/optionssidebar/options-sidebar';
import QuoteSidebar from 'components/quote-sidebar/quote-sidebar';
import { motion } from 'framer-motion';
import { ROUTES } from 'helpers/constants';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import { useUiState } from 'state/ui-state/ui-state';
import { useViewerState } from 'state/viewer-state/viewer-state';
import { ActionType } from '@swd_admin/cdc-viewer';
import InfoBanner from 'components/info-banner/info-banner';
import { isUrbanPavilionProduct } from 'state/appstate/appstate';

const ViewerScreenLarge: React.FunctionComponent = ({ children }) => {
  const [sidebarWidth, setSidebarWidth] = useState(33);
  const notificationRef = React.useRef<HTMLDivElement>(null);

  const sidebars = {
    [ROUTES.MATERIAL_SCREEN]: <MaterialsSidebar key={'materials'} />,
    [ROUTES.BUILD_SCREEN]: <BuildingSidebar key={'building'} />,
    [ROUTES.OPTIONS_SCREEN]: <OptionsSidebar key={'options'} />,
    [ROUTES.QUOTE_SCREEN]: <QuoteSidebar key={'quote'} />,
  };
  const { pathname } = useLocation();
  const { viewer } = useViewerState((state) => ({
    viewer: state.viewer,
  }));
  const { activeOption, setFocusType, focusType } = useUiState();

  useEffect(() => {
    if (pathname !== ROUTES.OPTIONS_SCREEN && focusType !== null) {
      viewer?.dispatch({
        type: ActionType.SetFocus,
        focusType: null,
      });
      setFocusType(null);
    }
  }, [pathname])

  useEffect(() => {
    const iPad = window.navigator.userAgent.toLowerCase().indexOf('ipad') !== -1;
    if (iPad) {
      function onOrientationChange() {
        const orientation = (window.screen.orientation || {}).type;
        const landscape = orientation.indexOf('landscape') !== -1;
        setSidebarWidth(landscape ? 25 : 33);
      }
      window.addEventListener('orientationchange', onOrientationChange);
      onOrientationChange();
      return () => {
        window.removeEventListener('orientationchange', onOrientationChange);
      };
    }
  }, []);

  return (
    <>
      <div
        style={{
          display: 'flex',
          height: '100%',
        }}
      >
        <motion.span
          style={{ flex: `1 0 ${sidebarWidth}%`, maxWidth: '532px' }}
          key={'sidebarContainer'}
          initial={{ translateX: 200, opacity: 0 }}
          animate={{
            translateX: 0,
            opacity: viewer ? 1 : 0.5,
            pointerEvents: viewer ? 'auto' : 'none',
            transition: { duration: 0.4, velocity: 1000 },
          }}
          exit={{
            position: 'relative',
            transition: { duration: 2 },
          }}
        >
          {activeOption ? <OptionParametersSidebar /> : sidebars[pathname]}
        </motion.span>

        <div
          style={{
            flex: `1 0 ${100 - sidebarWidth}%`,
            width: '100%',
            height: '100%',
            position: 'relative',
          }}
          ref={notificationRef}
        >
          <div
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              zIndex: 1000,
              backgroundColor: '#fff',
              borderBottomLeftRadius: 2,
              borderBottomRightRadius: 2,
            }}
            ref={notificationRef}
          >
          </div>
          {isUrbanPavilionProduct() && (
            <InfoBanner message="Please note the concrete slab needs to be larger than the footprint of the Urban Pavilion to accommodate the post base brackets (not shown in our Custom Design Center)." />
          )}
          {children}
        </div>
      </div>
      <Notification parent={notificationRef} />
    </>
  );
};

export default ViewerScreenLarge;
